"use client";

import { useEffect } from "react";

/**
 * Lazy-loads Sentry Session Replay for dogfood/preview environments.
 * Detection: aideco_dogfood=1 cookie, preview hostname, or development mode.
 */
export function ReplayBootstrap() {
  useEffect(() => {
    const isDogfood =
      document.cookie.includes("aideco_dogfood=1") ||
      window.location.hostname.includes("preview") ||
      process.env.NODE_ENV === "development";

    if (!isDogfood) return;

    // Use requestIdleCallback to avoid blocking
    const load = () => {
      import("@sentry/browser").then(({ getClient, replayIntegration }) => {
        const client = getClient();
        if (!client) return;

        const replay = replayIntegration({
          maskAllText: false, // Internal dogfood, we want to see text
          maskAllInputs: true, // Still mask passwords/inputs
          blockAllMedia: false,
        });

        client.addIntegration(replay);
      });
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(load);
    } else {
      setTimeout(load, 2000);
    }
  }, []);

  return null;
}
